import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';

import * as ConfirmationActions from './confirmation.actions';
import * as ConfirmationSelectors from './confirmation.selectors';
import { ConfirmationMetadata } from './confirmation-metadata';

@Injectable()
export class ConfirmationFacade {
  current$ = this.store.pipe(select(ConfirmationSelectors.getCurrentConfirmation));
  last$ = this.store.pipe(select(ConfirmationSelectors.getLastConfirmation));

  constructor(private store: Store) {}

  showConfirmation(metadata: ConfirmationMetadata) {
    this.store.dispatch(ConfirmationActions.showConfirmation({ metadata }));
  }

  accept(key: string, data: any) {
    this.store.dispatch(ConfirmationActions.confirmationAccepted({ key, data }));
  }

  reject(key: string, data: any) {
    this.store.dispatch(ConfirmationActions.confirmationRejected({ key, data }));
  }
}
